import React from 'react';
import '../../styles/content-mobile.css';

const VideoLessons = ({ subjectId = null }) => {
  // Show coming soon message for now
  return (
    <div className="video-lessons">
      <div className="coming-soon-container">
        <div className="coming-soon-content">
          <div className="coming-soon-icon">🎥</div>
          <h2>Videos Coming Soon!</h2>
          <p>We're working on creating high-quality video lessons to help you excel in your studies. Check back soon for engaging tutorials from experienced teachers.</p>
          <div className="coming-soon-features">
            <div className="feature-item">
              <span className="feature-icon">📚</span>
              <span>Comprehensive subject coverage</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">👨‍🏫</span>
              <span>Expert teacher instruction</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Exam-focused content</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Original code kept for future implementation
  /*
  if (loading) {
    return (
      <div className="video-lessons">
        <div className="loading-container">
          <div className="loading-spinner">Loading video lessons...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="video-lessons">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (videos.length === 0) {
    return (
      <div className="video-lessons">
        <div className="empty-state">
          <h3>No Video Lessons Available</h3>
          <p>Video lessons for this subject will be available soon.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="video-lessons">
      <div className="videos-header">
        <h2>Video Lessons</h2>
        <p>Watch engaging video tutorials from experienced teachers</p>
      </div>

      <div className="videos-content">
        <div className="video-player-section">
          {selectedVideo && (
            <div className="video-player">
              <div className="video-wrapper">
                <iframe
                  src={getYouTubeEmbedUrl(selectedVideo.youtubeVideoId)}
                  title={selectedVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="video-iframe"
                />
              </div>
              
              <div className="video-info">
                <h3>{selectedVideo.title}</h3>
                <p>{selectedVideo.description}</p>
                <div className="video-meta">
                  <span className="meta-item">
                    <span className="meta-icon">⏱️</span>
                    {formatDuration(selectedVideo.duration)}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="video-playlist">
          <h4>Lesson Playlist</h4>
          <div className="playlist-items">
            {videos.map((video, index) => (
              <div
                key={video.id}
                className={`playlist-item ${selectedVideo?.id === video.id ? 'active' : ''}`}
                onClick={() => setSelectedVideo(video)}
              >
                <div className="playlist-thumbnail">
                  <img 
                    src={video.thumbnailUrl} 
                    alt={video.title}
                    onError={(e) => {
                      e.target.src = `https://img.youtube.com/vi/${video.youtubeVideoId}/mqdefault.jpg`;
                    }}
                  />
                  <div className="duration-badge">
                    {formatDuration(video.duration)}
                  </div>
                </div>
                
                <div className="playlist-info">
                  <h5>{video.title}</h5>
                  <p>{video.description}</p>
                </div>
                
                <div className="playlist-play">
                  {selectedVideo?.id === video.id ? (
                    <span className="playing-indicator">▶️ Playing</span>
                  ) : (
                    <span className="play-icon">▶️</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
  */
};

export default VideoLessons;
